
export interface PackManifestFile {
    path: string;
    sizeBytes: number;
    type: 'content' | 'search';
    sha256?: string;
}

export interface PackManifest {
    version: string;
    createdAt: string;
    files: PackManifestFile[];
}

export interface ContentPack {
    [bookId: string]: {
        name: string;
        chapters: {
            [chapterNum: string]: {
                [verseNum: string]: string;
            };
        };
    };
}

export interface SearchIndexPack {
    [token: string]: string[]; // Array of verse IDs
}

export const DB_NAME = 'bible_offline_v1';
export const STORE_NAME = 'packs';
export const META_STORE_NAME = 'meta';

export type InstallState = 'idle' | 'checking' | 'downloading' | 'unpacking' | 'ready' | 'error';
